import { render, staticRenderFns } from "./TrackingHistory.vue?vue&type=template&id=e28385aa"
import script from "./TrackingHistory.vue?vue&type=script&lang=js"
export * from "./TrackingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports